import { render } from "./Basic.vue?vue&type=template&id=741a767c&scoped=true"
import script from "./Basic.vue?vue&type=script&lang=js"
export * from "./Basic.vue?vue&type=script&lang=js"

import "./Basic.vue?vue&type=style&index=0&id=741a767c&scoped=true&lang=css"

import exportComponent from "/home/www/omniauto/omniadmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-741a767c"]])

export default __exports__